const it = {
  // Navigation
  "nav.home": "Home",
  "nav.about": "Chi siamo",
  "nav.tokenomics": "Tokenomics",
  "nav.roadmap": "Roadmap",
  "nav.staking": "Staking",
  "nav.vesting": "Vesting",
  "nav.devupdates": "Aggiornamenti",
  "nav.fwb": "FWB",
  "nav.tokensale": "Vendita Token",
  
  // Common sections
  "common.learnMore": "Scopri di più",
  "common.buyNow": "Acquista ora",
  "common.contactUs": "Contattaci",
  "common.loading": "Caricamento",
  
  // Home page
  "home.hero.title": "L'evoluzione dei pagamenti digitali",
  "home.hero.subtitle": "eDOP Token: Il token di utilità per l'ecosistema finanziario della Repubblica Dominicana",
  "home.hero.cta": "Partecipa alla prevendita",
  "home.title": "eDOP: Rivoluzione Digitale",
  
  // Bolle della pagina Home
  "bubbles.home.revolution.title": "eDOP: Rivoluzione del Mercato",
  "bubbles.home.revolution.content": "Il token eDOP mira a fornire un'alternativa digitale efficiente e accessibile nell'ecosistema delle criptovalute, con un focus iniziale sui mercati emergenti e una visione di adozione globale.",
  
  "bubbles.home.ecosystem.title": "L'Ecosistema eDOP",
  "bubbles.home.ecosystem.content": "Non perdere l'opportunità di far parte della prossima generazione di soluzioni blockchain nel mondo delle criptovalute.",
  
  // About
  "about.title": "Informazioni su eDOP Token",
  "about.description": "eDOP Token è un token digitale progettato per rivoluzionare i pagamenti nella Repubblica Dominicana",
  
  // Pagina Chi Siamo
  "about.page.title": "Chi Siamo",
  
  // Bolle della pagina Chi Siamo
  "bubbles.about.edop.title": "Informazioni su eDOP",
  "bubbles.about.edop.content": "eDOP è un'alternativa digitale efficiente e accessibile nell'ecosistema crypto, progettata per affrontare i problemi di accesso finanziario, soprattutto nei mercati emergenti. Integra facilità d'uso con sicurezza, cercando un'adozione globale.",
  
  "bubbles.about.mission.title": "La Nostra Missione",
  "bubbles.about.mission.content": "Democratizzare l'accesso ai servizi finanziari digitali, offrendo strumenti accessibili che permettano alle persone di prendere il controllo delle proprie finanze senza intermediari costosi.",
  
  "bubbles.about.transparency.title": "Trasparenza",
  "bubbles.about.transparency.content": "Tutte le operazioni sono registrate in modo immutabile sulla blockchain, garantendo assoluta trasparenza. Inoltre, ci impegniamo a pubblicare i risultati degli audit di sicurezza per costruire fiducia.",
  
  "bubbles.about.innovation.title": "Innovazione",
  "bubbles.about.innovation.content": "Innoviamo offrendo una soluzione crypto centrata sull'utente per l'inclusione finanziaria, con un ecosistema che include pagamenti a basso costo, incentivi e sviluppi futuri come un DEX proprietario e un'applicazione mobile.",
  
  "bubbles.about.community.title": "Comunità",
  "bubbles.about.community.content": "Favoriamo una comunità impegnata attraverso un sistema di incentivi che premia la partecipazione, lo staking e l'uso attivo dell'ecosistema, cercando una distribuzione equilibrata e l'espansione della nostra base di utenti.",
  
  "bubbles.about.team.title": "Il Nostro Team",
  "bubbles.about.team.content": "Abbiamo un team multidisciplinare con ampia esperienza in finanza digitale, sviluppo blockchain e mercati emergenti, supportato da consulenti strategici in aree chiave come regolamentazione ed economia.",
  
  "bubbles.about.technology.title": "La Nostra Tecnologia",
  "bubbles.about.technology.content": "eDOP è un token BEP-20 che opera sulla BNB Smart Chain (BSC), scelta per il suo equilibrio ottimale tra velocità, sicurezza e costi accessibili, utilizzando smart contract sviluppati secondo le migliori pratiche.",
  
  "bubbles.about.speed.title": "Velocità",
  "bubbles.about.speed.content": "Grazie alla BNB Smart Chain, le transazioni con eDOP Token sono confermate rapidamente, tipicamente tra 3 e 15 secondi, offrendo un'efficienza superiore rispetto ai sistemi tradizionali e ad altre blockchain.",
  
  "bubbles.about.lowcost.title": "Basso Costo",
  "bubbles.about.lowcost.content": "eDOP offre commissioni drasticamente ridotte, che variano tra lo 0% e l'1% per transazione, rispetto al 5-10% dei servizi di rimessa tradizionali. Questo è reso possibile attraverso l'uso dell'efficiente rete BNB Smart Chain, smart contract ottimizzati e l'eliminazione degli intermediari, permettendo transazioni economiche, anche per micropagamenti.",
  
  "bubbles.about.security.title": "Sicurezza e Contatto",
  "bubbles.about.security.content": "La sicurezza è una priorità, implementando contratti controllati da aziende riconosciute, strumenti collaudati (OpenZeppelin), sistemi multi-firma e monitoraggio costante. Per domande, contattaci a info@edoptoken.com, admin@edoptoken.com, o attraverso i nostri social network ufficiali pubblicati sul nostro sito web.",
  
  // Tokenomics
  "tokenomics.title": "Distribuzione dei Token",
  "tokenomics.supply": "Fornitura totale",
  
  // Pagina di Tokenomics
  "tokenomics.page.title": "Tokenomics",
  "tokenomics.page.subtitle": "Distribuzione ed Economia del Token eDOP",
  
  "tokenomics.intro.title": "Tokenomics",
  "tokenomics.intro.content": "Contenuto: Il token eDOP ha un'offerta totale fissa di 1 miliardo di unità (1.000.000.000 eDOP). Il suo design economico include una distribuzione strategica per incentivare la partecipazione anticipata, premiare gli utenti a lungo termine attraverso lo staking, garantire liquidità di mercato e finanziare lo sviluppo continuo e l'adozione dell'ecosistema.",
  
  "tokenomics.distribution.title": "Distribuzione del Token",
  "tokenomics.distribution.content": "L'offerta totale di 1 miliardo di eDOP è allocata come segue:",
  "tokenomics.distribution.items": [
    "40% Prevendita pubblica: Per i primi adottanti.",
    "30% Ricompense di Staking: Distribuite in 2 anni per premiare i possessori.",
    "10% Liquidità: Bloccata per un minimo di 10 anni o a perpetuità per stabilità.",
    "10% Marketing e adozione: Per crescita e divulgazione.",
    "5% Sviluppo: Con rilascio graduale per il team (vesting).",
    "5% Inventario di Catena: Per operazioni tecniche dell'ecosistema."
  ],
  
  "tokenomics.purpose.title": "eDOP: Un Token con uno Scopo",
  "tokenomics.purpose.content": "Con un'offerta totale limitata a 1 miliardo di unità, il token eDOP è progettato per essere utile e sostenibile. La sua distribuzione strategica garantisce fondi per le ricompense di staking (30%), liquidità a lungo termine (10%) e crescita. Principalmente, puoi utilizzare eDOP come un mezzo di pagamento efficiente e a basso costo, o bloccarlo (staking) per ottenere ricompense e benefici aggiuntivi all'interno del nostro ecosistema finanziario digitale.",
  
  "tokenomics.utility.title": "Utilità del Token",
  "tokenomics.utility.items": [
    "Governance: I possessori di eDOP possono votare su proposte chiave che influenzano lo sviluppo e la direzione del progetto.",
    "Staking: Ottieni ricompense significative facendo staking dei tuoi token, con tassi annuali competitivi.",
    "Tariffe Ridotte: Gli utenti che possiedono eDOP godono di tariffe ridotte su tutte le transazioni all'interno della piattaforma.",
    "Accesso a Funzionalità Esclusive: Sblocca funzionalità avanzate e strumenti all'interno della nostra piattaforma.",
    "Mezzo di Pagamento: Utilizza eDOP per transazioni rapide ed economiche all'interno del nostro ecosistema."
  ],
  
  // Token sale
  "tokensale.title": "Vendita Token",
  "tokensale.subtitle": "Partecipa alla nostra prevendita",
  "tokensale.price": "Prezzo attuale",
  "tokensale.connect": "Connetti portafoglio",
  
  // Footer
  "footer.rights": "Tutti i diritti riservati",
  "footer.terms": "Termini e condizioni",
  "footer.privacy": "Politica sulla privacy",
  "footer.fwb": "Amici con Benefici",
  
  // Wallet
  "wallet.connect": "Connetti Portafoglio",
  
  // News
  "news.label": "NOTIZIE",
  
  // Pulsanti e testi aggiuntivi
  "cta.whitepaper": "Libro Bianco",
  
  // Pagina Politica sulla Privacy
  "privacy.page.title": "Politica sulla Privacy",
  
  // Bolle della Politica sulla Privacy
  "bubbles.privacy.commitment.title": "Impegno per la Tua Privacy",
  "bubbles.privacy.commitment.content": "In eDOP Token, ci impegniamo per la totale trasparenza e protezione dei tuoi dati. Come progetto incentrato sulla democratizzazione dell'accesso ai servizi finanziari digitali, comprendiamo l'importanza della fiducia.",
  
  "bubbles.privacy.nocollection.title": "Non Raccogliamo Informazioni",
  "bubbles.privacy.nocollection.content": "Per adempiere alla nostra missione di inclusione finanziaria, non richiediamo mai dati identificativi. Evita di essere vittima di phishing e non rivelare mai le tue chiavi private o frasi seed - eDOP Token non te le chiederà mai, ricordalo.",
  
  "bubbles.privacy.usage.title": "Come Utilizziamo le Tue Informazioni",
  "bubbles.privacy.usage.content": "Non raccogliamo dati personali o informazioni. Utilizziamo solo il tuo indirizzo wallet per operare, dati tecnici per mantenere la sicurezza della piattaforma e, facoltativamente, alcuni dettagli che migliorano la tua esperienza. Tutto secondo buone pratiche e senza condividere informazioni con terzi.",
  
  "bubbles.privacy.security.title": "Sicurezza e Protezione",
  "bubbles.privacy.security.content": "Applichiamo le stesse misure di sicurezza che proteggono i nostri smart contract: protocolli OpenZeppelin, multifirma nelle operazioni chiave, limiti per ridurre i rischi e monitoraggio costante. Tutto è allineato con i nostri audit, garantendo la sicurezza dei tuoi dati e asset digitali.",
  
  // Pagina Amici con Benefici (FWB)
  "fwb.page.title": "Amici con Benefici (FWB)",
  
  // Bolle della pagina FWB
  "bubbles.fwb.community.title": "Comunità eDOP (FWB)",
  "bubbles.fwb.community.content": "In eDOP, crediamo in una comunità globale che cerca di democratizzare l'accesso finanziario. Il nostro ecosistema è progettato affinché gli utenti prendano il controllo e collaborino verso un'economia digitale più equa, soprattutto nei mercati emergenti.",
  
  "bubbles.fwb.join.title": "Come Unirsi e Partecipare",
  "bubbles.fwb.join.content": "Diventa parte attiva di eDOP utilizzando il token per i pagamenti, partecipando al nostro programma di staking per supportare la rete e preparandoti a contribuire alla futura governance dell'ecosistema. La tua partecipazione è fondamentale per la nostra crescita.",
  "bubbles.fwb.join.date": "Data: 04 aprile 2025",
  
  "bubbles.fwb.benefits.title": "Benefici della Comunità eDOP",
  "bubbles.fwb.benefits.content": "Partecipando a eDOP, puoi guadagnare ricompense periodiche attraverso lo staking (dal 30% dell'offerta totale allocata). Inoltre, la detenzione attiva può darti accesso a benefici come sconti sulle commissioni o priorità nelle nuove funzionalità dell'ecosistema.",
  
  "bubbles.fwb.connect.title": "Connettiti con la Comunità",
  "bubbles.fwb.connect.content": "Rimani informato e connesso con il progetto eDOP. Trova link ai nostri canali ufficiali della comunità, documentazione tecnica e metodi di contatto direttamente sul nostro sito web ufficiale.",
  
  // Pagina Termini e Condizioni
  "terms.page.title": "Termini e Condizioni",
  
  // Bolle della pagina Termini
  "bubbles.terms.risk.title": "Avvertenze sui Rischi:",
  "bubbles.terms.risk.content": "L'investimento in eDOP Token comporta rischi significativi, tra cui elevata volatilità e possibile perdita totale o parziale del capitale. Il valore del token dipende dal mercato, non c'è garanzia di redditività e gli asset digitali non dispongono di assicurazione sui depositi. Considera attentamente la tua tolleranza al rischio prima di investire.",
  
  "bubbles.terms.liability.title": "Limitazione di Responsabilità",
  "bubbles.terms.liability.content": "La performance di eDOP Token è soggetta a rischi di mercato al di fuori del controllo dell'emittente (Servicios de Desarrollo de Algoritmos y Consultoría de Tecnología Blockchain, SRL). Non siamo responsabili per perdite derivanti da volatilità, fluttuazioni di liquidità o rischi inerenti all'investimento in asset digitali.",
  
  "bubbles.terms.issuer.title": "Emittente e Conformità Legale",
  "bubbles.terms.issuer.content": "eDOP Token è emesso da Servicios de Desarrollo de Algoritmos y Consultoría de Tecnología Blockchain, SRL, un'entità legalmente costituita. Cerchiamo di operare in conformità con le normative applicabili e disponiamo di consulenza legale in materia di asset digitali e diritto finanziario.",
  
  "bubbles.terms.contact.title": "Contatto",
  "bubbles.terms.contact.content": "Per domande relative a questi termini, al progetto eDOP Token o per ulteriori informazioni, puoi contattare la nostra Email: o consultare risorse aggiuntive sul nostro Sito Web.",
  
  // Pagina Aggiornamenti di Sviluppo
  "devupdates.page.title": "Aggiornamenti di Sviluppo",
  
  // Bolle della pagina Aggiornamenti di Sviluppo
  "bubbles.devupdates.intro.title": "Aggiornamenti di Sviluppo",
  "bubbles.devupdates.intro.content": "Secondo il piano tecnico descritto nel whitepaper, lo sviluppo di eDOP si concentra sulla creazione di componenti chiave come una piattaforma di pagamento a basso costo, un futuro exchange decentralizzato proprietario (DEX) e un'applicazione mobile. L'intero ecosistema è progettato per operare sulla BNB Smart Chain, cercando un equilibrio tra efficienza, sicurezza e accessibilità.",
  
  "bubbles.devupdates.latest.title": "Ultimi Aggiornamenti",
  "bubbles.devupdates.latest.content": "Basati sul piano originale del whitepaper e preparandoci per la nostra Fase 1 (stimata per fine Q2 2025), il nostro focus attuale include i preparativi per il lancio del token, l'attivazione della piattaforma di pagamento e l'assicurarsi le quotazioni iniziali su exchange. Per progressi reali e annunci confermati, consultare sempre i nostri canali ufficiali.",
  "bubbles.devupdates.latest.date": "Data: 28 aprile 2025",
  
  "bubbles.devupdates.events.title": "Prossimi Eventi Comunitari",
  "bubbles.devupdates.events.content": "La nostra comunità stabilirà un piano di interazione attiva con la comunità, menzionando strategie come webinar educativi regolari e presenza a eventi chiave del settore. Sebbene non siano specificate date per le prossime sessioni AMA o altri eventi specifici nel documento, il nostro impegno è mantenere una comunicazione fluida ed educativa.",
  "bubbles.devupdates.events.date": "Data: 28 aprile 2025",
  
  "bubbles.devupdates.technical.title": "Aggiornamento Tecnico: Audit degli Smart Contract",
  "bubbles.devupdates.technical.content": "In base al nostro approccio alla sicurezza delineato nel whitepaper, esiste l'impegno che gli smart contract di eDOP Token siano sottoposti ad audit da parte di società esterne riconosciute (sono menzionati esempi come CertiK o Hacken) prima del lancio. Si prevede di pubblicare tali report di audit sul nostro sito web per totale trasparenza con la comunità.",
  "bubbles.devupdates.technical.date": "Data: 28 aprile 2025",
  
  "bubbles.devupdates.partnership.title": "Annuncio di Partnership Strategica",
  "bubbles.devupdates.partnership.content": "Il nostro whitepaper stabilisce la strategia e l'importanza di formare alleanze strategiche per la crescita e l'utilità di eDOP Token, menzionando piani per collaborare con i commercianti, specialmente nei mercati emergenti. Tuttavia, il documento fondativo non contiene annunci specifici di partnership già firmate; descrive l'intenzione e l'approccio per cercarle come parte della roadmap.",
  "bubbles.devupdates.partnership.date": "Data: 28 aprile 2025",
  
  "bubbles.devupdates.previous.title": "Aggiornamenti Precedenti",
  "bubbles.devupdates.previous.content1": "Il whitepaper serve come piano maestro iniziale e presentazione del progetto eDOP Token. Per sua natura, gli aggiornamenti precedenti o le pietre miliari già completate dalla sua pubblicazione appariranno nei canali ufficiali per informazione.",
  "bubbles.devupdates.previous.content2": "Per accedere a un archivio di notizie, progressi e annunci precedenti, si prega di visitare le sezioni news/blog o i canali storici sui social network ufficiali di eDOP. Torna qui per vedere tutti i nostri aggiornamenti precedenti!",

  // Roadmap Page
  "roadmap.page.title": "Tabella di Marcia",
  "roadmap.page.subtitle": "La nostra visione e obiettivi per il futuro",

  // Roadmap Phases
  "roadmap.phase1.title": "Fase 1: Fondamenta e Lancio",
  "roadmap.phase1.description": "Sviluppo dei fondamentali del token e lancio della prevendita",
  "roadmap.phase1.items": [
    "Sviluppo e audit dello Smart Contract",
    "Prevendita del Token",
    "Costruzione della comunità",
    "Lancio del sito web"
  ],

  "roadmap.phase2.title": "Fase 2: Lancio sul Mercato ed Espansione",
  "roadmap.phase2.description": "Listing su DEX e inizio delle campagne di marketing",
  "roadmap.phase2.items": [
    "Listing su DEX",
    "Campagne di marketing",
    "Partnership strategiche",
    "Crescita della comunità"
  ],

  "roadmap.phase3.title": "Fase 3: Sviluppo dei Prodotti",
  "roadmap.phase3.description": "Sviluppo della piattaforma di pagamento e integrazione del portafoglio",
  "roadmap.phase3.items": [
    "Beta della piattaforma di pagamento",
    "Integrazione del portafoglio",
    "Integrazione dei commercianti",
    "Audit di sicurezza"
  ],

  "roadmap.phase4.title": "Fase 4: Espansione dell'Ecosistema",
  "roadmap.phase4.description": "Ampliamento dell'ecosistema e nuove funzionalità",
  "roadmap.phase4.items": [
    "Lancio dell'App mobile",
    "Integrazione Cross-Chain",
    "Implementazione della Governance",
    "Nuove partnership"
  ],

  // Roadmap Status
  "roadmap.status.completed": "Completato",
  "roadmap.status.inProgress": "In Corso",
  "roadmap.status.upcoming": "In Arrivo",

  // Roadmap Additional Sections
  "roadmap.vision.title": "La Nostra Visione",
  "roadmap.vision.content": "Plasmare il futuro dei pagamenti digitali nella Repubblica Dominicana e oltre",

  "roadmap.updates.title": "Aggiornamenti Recenti",
  "roadmap.updates.content": "Rimani informato sui nostri progressi",

  // Pagina di Vesting
  "vesting.page.title": "Piattaforma di Vesting eDOP",
  
  // Pagina Vesting - Bolle
  "bubbles.vesting.platform.title": "Piattaforma di Vesting eDOP",
  "bubbles.vesting.platform.content": "I token destinati al team di sviluppo (5% del totale) non vengono consegnati tutti in una volta. Prima, sono completamente bloccati per 120 giorni. Poi, il team riceve una piccola porzione ogni mese (un 2% lineare della loro allocazione). Questo processo è chiamato vesting e assicura che il team rimanga impegnato nel progetto eDOP Token a lungo termine.",
  
  "bubbles.vesting.emission.title": "Emissione Graduale di Token",
  "bubbles.vesting.emission.content": "eDOP controlla il rilascio lento di token con il vesting per il team e la distribuzione graduale delle ricompense di staking (30% in 2 anni). Questa emissione controllata mira a evitare bruschi cali di prezzo e ad allineare la circolazione dei token con la crescita del progetto.",

  // Pagina di Staking
  "staking.page.title": "Piattaforma di Staking eDOP",
  
  // Bolle di Staking
  "bubbles.staking.platform.title": "Piattaforma di Staking eDOP",
  "bubbles.staking.platform.content": "È la funzione all'interno di eDOP dove puoi bloccare i tuoi token per supportare il progetto. In cambio del loro blocco, la piattaforma ti dà premi (più token eDOP).",
  
  "bubbles.staking.benefits.title": "Vantaggi dello Staking",
  "bubbles.staking.benefits.items": [
    "Guadagni più eDOP: Ricevi token extra come ricompensa per aver bloccato i tuoi.",
    "Partecipi alle decisioni: Ti dà l'opportunità di votare o influenzare il futuro del progetto.",
    "Sostieni il token: Aiuti a rendere il valore del token più stabile a lungo termine."
  ],
  
  "bubbles.staking.rewards.title": "Ricompense",
  "bubbles.staking.rewards.content": "Potrai richiedere le tue ricompense accumulate una volta che la funzione di riscatto sarà attiva sulla piattaforma.",
  
  // Componente StakingBox4
  "stakingBox4.totalRewards": "RICOMPENSE TOTALI",
  "stakingBox4.claimRewards": "Richiedi Ricompense",
  "stakingBox4.processing": "In elaborazione...",
  "stakingBox4.claimed": "Richiesto",
  "stakingBox4.success": "Successo!",
  "stakingBox4.info": "INFO",
  "stakingBox4.accept": "Accetta",
  "stakingBox4.noRewards": "Nessuna ricompensa disponibile da richiedere",
  "stakingBox4.claimedSuccess": "Ricompense richieste con successo! Hai ricevuto {{amount}} $eDOP",
  "stakingBox4.errorClaiming": "Impossibile richiedere le ricompense",
  "stakingBox4.userRejected": "La transazione è stata rifiutata dall'utente",
  "stakingBox4.insufficientFunds": "Fondi insufficienti per eseguire la transazione",
  "stakingBox4.contractRejection": "La transazione è stata rifiutata dal contratto",
  
  // Componente StakingBox3
  "stakingBox3.estimatedRewards": "RICOMPENSE STIMATE",
  "stakingBox3.rewardsDynamic": "• La percentuale di ricompense è dinamica",
  "stakingBox3.monthly": "• Mensile = {{rate}}%",
  "stakingBox3.daily": "• Giornaliero = {{rate}}%",
  
  // Componente StakingBox2
  "stakingBox2.poolPercentage": "% DEL POOL",
  "stakingBox2.stakedBalance": "SALDO IN STAKING",
  "stakingBox2.processing": "In elaborazione...",
  "stakingBox2.withdrawTokens": "Ritira Token",
  "stakingBox2.success": "Successo!",
  "stakingBox2.info": "INFO",
  "stakingBox2.accept": "Accetta",
  "stakingBox2.tokensWithdrawn": "Token ritirati con successo",
  "stakingBox2.errorWithdrawing": "Impossibile ritirare i token",
  "stakingBox2.userRejected": "La transazione è stata rifiutata dall'utente",
  "stakingBox2.insufficientFunds": "Fondi insufficienti per eseguire la transazione",
  "stakingBox2.contractRejection": "La transazione è stata rifiutata dal contratto",
  "stakingBox2.infoModal.title": "Percentuale del Pool",
  "stakingBox2.infoModal.content": "Questa percentuale rappresenta la proporzione dei tuoi token in staking rispetto al totale dei token in staking. Maggiore è la tua percentuale, maggiore sarà la proporzione di ricompense che riceverai.",
  "stakingBox2.infoModal.understood": "Capito",
  
  // Componente StakingSupply
  "stakingSupply.title": "Offerta Totale di Staking",
  "stakingSupply.totalSupply": "Offerta Totale (Milioni)",
  
  // Mesi abbreviati per i grafici
  "months.jan": "Gen",
  "months.feb": "Feb",
  "months.mar": "Mar",
  "months.apr": "Apr",
  "months.may": "Mag",
  "months.jun": "Giu",
  "months.jul": "Lug",
  "months.aug": "Ago",
  "months.sep": "Set",
  "months.oct": "Ott",
  "months.nov": "Nov",
  "months.dec": "Dic",
  
  // Componente PresaleBox
  "presaleBox.buyMessage": "ACQUISTA I TUOI TOKEN $eDOP ORA",
  "presaleBox.days": "Giorni",
  "presaleBox.hours": "Ore",
  "presaleBox.minutes": "Min",
  "presaleBox.seconds": "Sec",
  "presaleBox.presalePending": "Prevendita in arrivo",
  "presaleBox.presaleCompleted": "Prevendita completata",
  "presaleBox.stage": "Fase {{current}} di {{total}}",
  "presaleBox.fundsRaised": "USDT raccolti: ${{raised}} / ${{goal}}",
  "presaleBox.tokensPurchased": "I tuoi Token eDOP Acquistati: {{amount}}",
  "presaleBox.tokensStaked": "I tuoi token $eDOP in staking = {{amount}}",
  "presaleBox.tokenPrice": "1 eDOP = ${{price}} USDT",
  "presaleBox.payWith": "Paga con {{currency}}",
  "presaleBox.receive": "Ricevi $eDOP",
  "presaleBox.maximum": "Massimo",
  "presaleBox.insufficientFunds": "Non hai abbastanza {{currency}} per pagare questa transazione.",
  "presaleBox.buyWithBnb": "Acquista con {{symbol}}",
  "presaleBox.buyWithUsdt": "Acquista con {{symbol}}",
  "presaleBox.buyWithCard": "Acquista con Carta",
  "presaleBox.goToDex": "Vai al DEX",
  "presaleBox.balance": "Saldo in {{currency}}:",
  "presaleBox.connectWallet": "Connetti il tuo portafoglio",
  "presaleBox.reloadBnb": "Non hai abbastanza BNB? Ricarica qui",
  "presaleBox.developedBy": "Sviluppato da",
  
  // Modal informativo per PresaleBox
  "presaleBox.infoModal.title": "Attenzione!",
  "presaleBox.infoModal.tokensPurchased": "Il totale dei token acquistati sono tutti i token acquisiti con il portafoglio collegato. Questo include tutti i token in staking e non in staking.",
  "presaleBox.infoModal.ok": "OK",
  "presaleBox.infoModal.stakeableTokens": "I $eDOP non reclamati acquistati con ETH o USDT ERC-20 possono essere utilizzati in staking ora. Si prega di notare che tutti i token utilizzati nello staking anticipato possono essere ritirati 7 giorni dopo l'attivazione della richiesta di token, che avverrà dopo la conclusione della prevendita.",
  
  // Avvisi per PresaleBox
  "presaleBox.alert.connectWallet": "Si prega di connettere prima il portafoglio",
  "presaleBox.alert.enterValidAmount": "Si prega di inserire un importo valido",
  "presaleBox.alert.presaleNotStarted": "La prevendita inizia il 01 giugno 2025. Si prega di attendere l'inizio della prevendita.",
  "presaleBox.alert.confirmInWallet": "Si prega di confermare la transazione nel portafoglio...",
  "presaleBox.alert.purchaseSuccess": "Acquisto completato con successo! Hai acquistato {{amount}} token eDOP",
  "presaleBox.alert.paymentMethodNotSupported": "Metodo di pagamento non supportato",
  
  // Errori semplificati per PresaleBox
  "presaleBox.error.insufficientTokens": "Non ci sono abbastanza token disponibili al momento. Si prega di riprovare più tardi.",
  "presaleBox.error.userDenied": "Transazione rifiutata. Devi confermare la transazione nel tuo portafoglio per continuare.",
  "presaleBox.error.gas": "Errore di gas per la transazione. Assicurati di avere abbastanza BNB per coprire i costi del gas.",
  "presaleBox.error.nonce": "Errore nella sequenza della transazione. Prova ad aggiornare la pagina e riprova.",
  "presaleBox.error.contractFailure": "Transazione fallita. Il contratto potrebbe essere in pausa o esaurito i token.",
  "presaleBox.error.generic": "Errore di transazione. Si prega di riprovare più tardi.",
  
  // Rete richiesta per PresaleBox
  "presaleBox.network.bnbMainnet": "BNB Smart Chain",
  "presaleBox.network.bnbTestnet": "BSC Testnet",
  "presaleBox.network.bnbBoth": "BNB Smart Chain o BSC Testnet",
  "presaleBox.network.usdtBep20": "BNB Smart Chain (per USDT BEP-20)",
  "presaleBox.network.usdtErc20": "Ethereum (per USDT ERC-20)",
  "presaleBox.network.usdtTestnet": "BSC Testnet (per USDT Testnet)",
  "presaleBox.network.usdtOptions": "Ethereum (per USDT ERC-20) o BNB Smart Chain (per USDT BEP-20)",
  "presaleBox.network.usdtOptionsTestnet": "Ethereum (per USDT ERC-20) o BNB Smart Chain/Testnet (per USDT BEP-20)",
  "presaleBox.network.compatible": "rete compatibile",
  "presaleBox.network.changeNetwork": "Per pagare con {{method}}, devi passare alla rete {{network}}",
  
  // Messaggi di errore per i contratti
  "contracts.error.invalidConfig": "Contratto {{contractName}} non configurato correttamente",
  "contracts.error.initialization": "Errore durante l'inizializzazione del contratto {{contractName}}: {{error}}",
  "contracts.error.notInitialized": "Il contratto non è inizializzato",
  "contracts.error.walletNotConnected": "Wallet non connesso. Per favore, connetti il tuo wallet per continuare",
  "contracts.error.transaction": "Errore di transazione: {{error}}",
  "errors.contractInitialization": "Errore durante l'inizializzazione dei contratti",
  
  // Messaggi di errore per i wallet
  "wallet.error.noMetamask": "MetaMask non è installato",
  "wallet.error.noAccount": "Impossibile ottenere l'account",
  "wallet.error.networkNotSupported": "Rete non supportata",
  "wallet.error.connection": "Errore durante la connessione del wallet",
  "wallet.error.networkSwitch": "Errore durante il cambio di rete",
  
  // Messaggi di errore per la prevendita
  "presale.error.connectWalletFirst": "Connetti prima il tuo wallet",
  "presale.error.contractNotReady": "Il contratto di prevendita non è pronto",
  "presale.error.noSigner": "Impossibile ottenere il firmatario. Riconnetti il tuo wallet.",
  "presale.error.priceChanged": "Errore di prezzo: Il prezzo è cambiato. Aggiorna la pagina.",
  "presale.error.userRejected": "Transazione rifiutata dall'utente",
  "presale.error.insufficientFunds": "Fondi insufficienti per completare la transazione",
  "presale.error.purchaseError": "Errore di acquisto: {{error}}",
  "presale.error.unknown": "Sconosciuto",
  "presale.error.usdtApprovalError": "Errore di approvazione USDT",
  "presale.error.cannotClaimTokens": "Impossibile richiedere i token in questo momento",
  
  // Messaggi della console - solo per sviluppatori, non mostrati agli utenti
  "console.contracts.initialized": "Contratti di prevendita inizializzati con successo",
  "console.contracts.initError": "Errore durante l'inizializzazione dei contratti:",
  "console.tokens.availableError": "Errore durante il caricamento dei token disponibili:",
  "console.exchangeRates.error": "Errore durante il recupero dei tassi di cambio:",
  "console.price.error": "Errore durante l'ottenimento del prezzo dal contratto:",
  "console.price.fromContract": "Prezzo ottenuto dal contratto:",
  "console.price.contractError": "Errore durante l'ottenimento del prezzo dal contratto:",
  "console.price.usingFallback": "Utilizzo del prezzo di fallback:",
  "console.bnb.buying": "Acquisto con BNB: {{amount}} BNB per ottenere {{tokensToReceive}} token",
  "console.price.perToken": "Prezzo per token: {{price}} USDT",
  "console.signer.available": "Firmatario disponibile: {{available}}",
  "console.account.current": "Account attuale: {{account}}",
  "console.bnb.success": "Acquisto BNB riuscito:",
  "console.bnb.error": "Errore durante l'acquisto con BNB:",
  "console.usdt.approving": "Approvazione della spesa USDT...",
  "console.price.fromContractUsdt": "Prezzo ottenuto dal contratto (USDT):",
  "console.price.contractErrorUsdt": "Errore durante l'ottenimento del prezzo dal contratto (USDT):",
  "console.price.usingFallbackUsdt": "Utilizzo del prezzo di fallback (USDT):",
  "console.usdt.buying": "Acquisto con USDT: {{amount}} USDT con prezzo {{price}} per token",
  "console.tokens.expected": "Token previsti: {{tokens}}",
  "console.usdt.success": "Acquisto USDT riuscito:",
  "console.usdt.error": "Errore durante l'acquisto con USDT:",
  "console.tokens.claimSuccess": "Token richiesti con successo:",
  "console.tokens.claimError": "Errore durante la richiesta dei token:",
  "console.purchases.error": "Errore durante il recupero dei dati di acquisto:",

  // Messaggi del Ticker
  "ticker.message1": "1️⃣ Unisciti alla prevendita eDOP! 🚀 Approfitta dei prezzi esclusivi prima del lancio. 🔥",
  "ticker.message2": "2️⃣ eDOP rivoluziona il mercato! 💎 Unisciti all'ecosistema e assicurati il tuo posto nella nuova era digitale. ⚡",
  "ticker.message3": "3️⃣ Ultimi giorni della prevendita eDOP! ⏳ Non rimanere fuori, ottieni i tuoi token prima che sia troppo tardi. 🎯",

  // Meta Tag
  "meta.description": "eDOP Token - La valuta dell'ecosistema finanziario dominicano"
};

export default it;